import { render } from "./ClientManagementView.vue?vue&type=template&id=76ab7cb9&scoped=true"
import script from "./ClientManagementView.vue?vue&type=script&lang=js"
export * from "./ClientManagementView.vue?vue&type=script&lang=js"

import "./ClientManagementView.vue?vue&type=style&index=0&id=76ab7cb9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ab7cb9"]])

export default __exports__